__turbopack_context__.v({
  "content": "object-page-section-module-scss-module__qlgkoq__content",
  "header": "object-page-section-module-scss-module__qlgkoq__header",
  "wrapper": "object-page-section-module-scss-module__qlgkoq__wrapper",
});
